import React from 'react';
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { Box, Chip, IconButton, Stack, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';
import { getTriggerTypeLabel, summarizeTrigger } from '../../utils/triggerFormUtils';

export default function TriggerSummaryCard({ trigger, onEdit, onDelete, disabled = false }) {
  const { semantic, radiusPx, typographyStyles } = useFeatureTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      sx={{
        p: 1.25,
        borderRadius: radiusPx.md,
        border: `1px solid ${semantic.borders.border}`,
        bgcolor: semantic.surfaces.surface,
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Chip
            size="small"
            label={getTriggerTypeLabel(trigger?.trigger_type)}
            variant="outlined"
          />
          <Typography sx={{ ...typographyStyles.caption, color: semantic.text.secondary }}>
            {summarizeTrigger(trigger)}
          </Typography>
        </Stack>
      </Box>
      <Stack direction="row" spacing={0.5}>
        <IconButton size="small" disabled={disabled} onClick={() => onEdit?.()}>
          <EditOutlined fontSize="small" />
        </IconButton>
        <IconButton size="small" disabled={disabled} onClick={() => onDelete?.()}>
          <DeleteOutlineOutlined fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
